import { createFileRoute } from "@tanstack/react-router";
import { NotaryFaqHub } from "@/components/NotaryFaqHub";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";

const URL = `${SEO_SITE}/en/notary/faq`;

export const Route = createFileRoute("/en/notary/faq")({
  head: () => ({
    meta: [
      { title: ctaTitle("Notary Public Thailand — 300 Keywords & 150 Q&A | NYC Legal", "/en/notary/faq", "en")},
      {
        name: "description",
        content:
          ctaDesc("Notary Public Thailand — 150+ Q&A across 300 keywords: 34 acts, 77 provinces, embassy & Apostille. Start with a free review before you file anything.", "/en/notary/faq", "en"),
      },
      { property: "og:title", content: ctaTitle("Notary Public Thailand — 300 Keywords & 150 Q&A", "/en/notary/faq", "en")},
      {
        property: "og:description",
        content:
          ctaDesc("8 keyword clusters · Thai misspelling glossary · 150 Q&A on every step — send a photo of your document and get your exact timeline today.", "/en/notary/faq", "en"),
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "en", href: URL },
      { rel: "alternate", hrefLang: "th", href: `${SEO_SITE}/notary/faq` },
      { rel: "alternate", hrefLang: "x-default", href: `${SEO_SITE}/notary/faq` },
    ],
  }),
  component: () => <NotaryFaqHub lang="en" />,
});
